import store from '@/store'
import router from '@/router'

export default [
  {
    name: 'status',
    onClick: event => {
      const BTN_CLICKED = event.button
      if (BTN_CLICKED == 0) {
        store.commit('setOpenedSettings', true)
      }
    },
  },
  {
    name: 'settings',
    onClick: event => {
      const BTN_CLICKED = event.button
      router.push({ name: 'settingsAccount' })
      if (BTN_CLICKED == 0) {
        router.push({ name: 'settingsAccount' })
      }
      if (BTN_CLICKED == 1) {
        const routeData = router.resolve({
          name: 'settingsAccount',
        })
        window.open(routeData.href, '_blank')
      }
      const inEmploers = router.history.current.path.indexOf(`/employers/${store.getters.user.id}`)
      if (inEmploers != -1) {
        store.dispatch('GET_EMPLOYER', store.getters.user.id)
      }
    },
  },
  {
    name: 'logout',
    onClick: event => {
      const BTN_CLICKED = event.button
      if (BTN_CLICKED == 0) {
        store.dispatch('LOGOUT')
      }
      if (BTN_CLICKED == 1) {
        const routeData = router.resolve({
          name: 'auth',
        })
        window.open(routeData.href, '_blank')
      }
    },
  },
]
